// Duplicate track children so the marquee loops seamlessly
document.querySelectorAll('.review-showcase__track').forEach((track) => {
  const cards = Array.from(track.children);
  if (cards.length === 0) return;
  // Clone all cards and append — CSS animates to -50% which lands back at start
  cards.forEach((card) => track.appendChild(card.cloneNode(true)));
});
